module.exports = __webpack_public_path__ + "images/204adeaeea6716fd0ba06b8341699a359809605b72cc3aad3902ca08105c6060.svg";